import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import useAuth from '@/hooks/useAuth';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { to: '/admin/agents', label: 'Agentes', icon: '🧠' },
  { to: '/admin/cities', label: 'Cidades', icon: '🏙️' },
  { to: '/admin/zones', label: 'Zonas', icon: '🗺️' },
  { to: '/admin/pois', label: 'POIs', icon: '📍' },
  { to: '/admin/badges', label: 'Medalhas', icon: '🏅' },
  { to: '/admin/missions', label: 'Missões', icon: '📜' },
  { to: '/admin/partners', label: 'Parceiros', icon: '🤝' },
  { to: '/admin/offers', label: 'Ofertas', icon: '🎁' },
  { to: '/admin/users', label: 'Utilizadores', icon: '👥' },
  { to: '/admin/redemptions', label: 'Resgates', icon: '🎫' },
  { to: '/admin/fraud-logs', label: 'Fraude', icon: '🚨' },
  { to: '/admin/analytics', label: 'Analytics', icon: '📈' },
  { to: '/admin/notifications', label: 'Notificações', icon: '🔔' },
  { to: '/admin/suggestions', label: 'Sugestões IA', icon: '✨' },
];

export default function AdminLayout() {
  const { handleLogout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const sidebar = (
    <aside className="flex h-full w-72 max-w-[82vw] flex-shrink-0 flex-col border-r border-accent/20 bg-surface text-fg md:w-56">
      <div className="border-b border-accent/20 p-4">
        <div className="font-serif text-lg font-bold text-accent">⚓ Hakken Admin</div>
        <div className="mt-0.5 text-xs text-fg/40">Painel de Controlo</div>
      </div>
      <nav className="flex-1 overflow-y-auto py-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              `flex min-h-11 items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
                isActive
                  ? 'border-r-2 border-accent bg-accent/20 text-accent'
                  : 'text-fg/65 hover:bg-fg/5 hover:text-fg'
              }`
            }
          >
            <span className="w-5 text-center text-base" aria-hidden="true">{item.icon}</span>
            <span className="truncate">{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <button
        type="button"
        onClick={handleLogout}
        className="border-t border-accent/20 p-4 text-left text-sm font-bold text-red-400 hover:text-red-300"
      >
        🚪 Sair
      </button>
    </aside>
  );

  return (
    <div className="h-full bg-background font-body text-fg md:flex">
      <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-accent/20 bg-surface px-4 md:hidden">
        <div>
          <div className="font-serif text-base font-bold text-accent">⚓ Hakken Admin</div>
          <div className="text-[11px] text-fg/40">Painel de Controlo</div>
        </div>
        <button
          type="button"
          onClick={() => setMenuOpen(true)}
          className="rounded-lg border border-accent/35 bg-accent/10 px-3 py-2 text-sm font-bold text-accent"
          aria-label="Abrir menu"
        >
          Menu
        </button>
      </header>

      <div className="hidden md:block">{sidebar}</div>

      {menuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <button
            type="button"
            aria-label="Fechar menu"
            className="absolute inset-0 bg-black/70"
            onClick={() => setMenuOpen(false)}
          />
          <div className="relative h-full shadow-2xl">{sidebar}</div>
        </div>
      )}

      <main className="h-[calc(100%-4rem)] overflow-auto p-4 md:h-full md:flex-1 md:p-6">
        <Outlet />
      </main>
    </div>
  );
}
